module.exports = __webpack_public_path__ + "img/5.3fee45b6.png";